export const commonRouters = [
  {
    path: '/',
    name: 'start',
    redirect: '/index',
    component: require('@/view/start/index').default,
    meta: {
      title: '体育教育教学',
      breadList: [{ name: '首页', path: '/index' }],
    },
    children: [
      {
        path: '/index',
        name: 'index',
        component: require('@/view/home/index').default,
        meta: {
          title: '体育教育教学',
          breadList: [{ name: '首页', path: '/index' }],
        },
      },
      {
        path: '/department',
        name: 'department',
        component: require('@/view/department/index').default,
        meta: {
          title: '部门机构',
          breadList: [
            { name: '首页', path: '/index' },
            { name: '部门机构', path: '/department' },
          ],
        },
      },
      {
        path: '/article',
        name: 'article',
        component: require('@/view/info/index').default,
        meta: {
          breadList: [
            { name: '首页', path: '/index' },
            { name: '部门机构', path: '/department' },
            { name: '文章', path: '/article' },
          ],
        },
      },
      {
        path: '/teacher',
        name: 'teacher',
        component: require('@/view/teacher/index').default,
        meta: {
          breadList: [
            { name: '首页', path: '/index' },
            { name: '体育教学', path: '/teaching' },
            { name: '教师信息', path: '/teacher' },
          ],
        },
      },
      {
        path: '/clubInfo',
        name: 'clubInfo',
        component: require('@/view/club/clubInfo').default,
        meta: {
          breadList: [
            { name: '首页', path: '/index' },
            { name: '体育社团', path: '/department' },
            { name: '社团详情', path: '/clubInfo' },
          ],
        },
      },
      {
        path: '/video',
        name: 'video',
        component: require('@/view/video/index').default,
        meta: {
          breadList: [
            { name: '首页', path: '/index' },
            { name: '体育教学', path: '/teaching' },
            { name: '教师信息', path: '/video' },
          ],
        },
      },
      {
        path: '/videoPlay',
        name: 'videoPlay',
        component: require('@/view/video/detail').default,
        meta: {
          breadList: [
            { name: '首页', path: '/index' },
            { name: '体育教学', path: '/teaching' },
            { name: '教学视频', path: '/videoPlay' },
          ],
        },
      },
      {
        path: '/bookDetail',
        name: 'bookDetail',
        component: require('@/view/video/bookdetail').default,
        meta: {
          breadList: [
            { name: '首页', path: '/index' },
            { name: '体育教学', path: '/teaching' },
            { name: '教学教材', path: '/bookDetail' },
          ],
        },
      },
      {
        path: '/document',
        name: 'document',
        component: require('@/view/document/index').default,
        meta: {
          breadList: [
            { name: '首页', path: '/index' },
            { name: '政策文件', path: '/document' },
          ],
        },
      },
      {
        path: '/teaching',
        name: 'teaching',
        component: require('@/view/teaching/index').default,
        meta: {
          breadList: [
            { name: '首页', path: '/index' },
            { name: '体育教学', path: '/teaching' },
          ],
        },
      },
      {
        path: '/group',
        name: 'group',
        component: require('@/view/group/index').default,
        meta: {
          breadList: [
            { name: '首页', path: '/index' },
            { name: '校园群体', path: '/group' },
          ],
        },
      },
      {
        path: '/competition',
        name: 'competition',
        component: require('@/view/competition/index').default,
        meta: {
          breadList: [
            { name: '首页', path: '/index' },
            { name: '运动竞训', path: '/competition' },
          ],
        },
      },
      {
        path: '/health',
        name: 'health',
        component: require('@/view/health/index').default,
        meta: {
          breadList: [
            { name: '首页', path: '/index' },
            { name: '体质健康', path: '/health' },
          ],
        },
      },
      {
        path: '/club',
        name: 'club',
        component: require('@/view/club/index').default,
        meta: {
          breadList: [
            { name: '首页', path: '/index' },
            { name: '体育社团', path: '/club' },
          ],
        },
      },
      {
        path: '/teamInfo',
        name: 'teamInfo',
        component: require('@/view/competition/teaminfo').default,
        meta: {
          breadList: [
            { name: '首页', path: '/index' },
            { name: '运动竞训', path: '/competition' },
            { name: '队伍风采', path: '/teamInfo' },
          ],
        },
      },
      {
        path: '/research',
        name: 'research',
        component: require('@/view/research/index').default,
        meta: {
          breadList: [
            { name: '首页', path: '/index' },
            { name: '科学研究', path: '/research' },
          ],
        },
      },
      {
        path: '/stadium',
        name: 'stadium',
        component: require('@/view/stadium/index').default,
        meta: {
          breadList: [
            { name: '首页', path: '/index' },
            { name: '体育场馆', path: '/stadium' },
          ],
        },
      },
      {
        path: '/union',
        name: 'union',
        component: require('@/view/union/index').default,
        meta: {
          breadList: [
            { name: '首页', path: '/index' },
            { name: '工会工作', path: '/union' },
          ],
        },
      },
      {
        path: '/report',
        name: 'report',
        component: require('@/view/report/index').default,
        meta: {
          breadList: [
            { name: '首页', path: '/index' },
            { name: '新闻报道', path: '/report' },
          ],
        },
      },
      {
        path: '/search',
        name: 'search',
        component: require('@/view/search/index').default,
        meta: {
          breadList: [
            { name: '首页', path: '/index' },
            { name: '搜索', path: '/search' },
          ],
        },
      },
    ],
  },
  {
    path: '/cockpit/index',
    name: 'cockpitindex',
    component: require('@/view/cockpit/index').default,
    meta: {
      title: '驾驶舱',
      breadList: [{ name: '驾驶舱', path: '/cockpit/index' }],
    },
    children: [],
  },
  {
    path: '/cockpit/sport',
    name: 'cockpit',
    component: require('@/view/cockpit/cockpit').default,
    meta: {
      title: '课外锻炼驾驶舱',
      keepAlive: true,
      breadList: [{ name: '驾驶舱', path: '/cockpit' }],
    },
    children: [],
  },
  {
    path: '/cockpit/academic',
    name: 'academic',
    title: '学业预警驾驶舱',
    component: require('@/view/cockpit/academic').default,
    meta: {
      breadList: [{ name: '学业预警驾驶舱', path: '/cockpit/academic' }],
    },
    children: [],
  },
  {
    path: '/cockpit/test',
    name: 'test',
    component: require('@/view/cockpit/test').default,
    meta: {
      title: '体质测试驾驶舱',
      breadList: [{ name: '体质测试驾驶舱', path: '/cockpit/test' }],
    },
    children: [],
  },
  {
    path: '/cockpit/attendance',
    name: 'acadattendanceemic',
    component: require('@/view/cockpit/attendance').default,
    meta: {
      title: '课程考勤驾驶舱',
      breadList: [{ name: '学生课程考勤预警驾驶舱', path: '/cockpit/attendance' }],
    },
    children: [],
  },
  {
    path: '/cockpit/venues',
    name: 'venue',
    component: require('@/view/cockpit/venues').default,
    meta: {
      title: '场馆驾驶舱',
      breadList: [{ name: '场馆详情', path: '/cockpit/venues' }],
    },
    children: [],
  },

  {
    path: '/cockpit/competition',
    name: 'cockpitcompetition',
    component: require('@/view/cockpit/competition').default,
    meta: {
      title: '体育竞赛驾驶舱',
      breadList: [{ name: '体育竞赛驾驶舱', path: '/cockpit/competition' }],
    },
    children: [],
  },
  {
    path: '/cockpit/sportteam',
    name: 'sportcom',
    component: require('@/view/cockpit/sportteam/sportteam').default,
    meta: {
      title: '运动竞训驾驶舱',
      breadList: [{ name: '运动竞训驾驶舱', path: '/cockpit/sportteam/sportteam' }],
    },
    children: [],
  },
  {
    path: '/cockpit/clubcockpit',
    name: 'clubac',
    component: require('@/view/cockpit/clubcockpit/clubcockpit').default,
    meta: {
      title: '社团活动驾驶舱',
      breadList: [{ name: '社团活动驾驶舱', path: '/cockpit/clubcockpit/clubcockpit' }],
    },
    children: [],
  },
  {
    path: '/cockpit/heartrate',
    name: 'heartrate',
    component: require('@/view/cockpit/heartrate/heartcockpit').default,
    meta: {
      title: '教学班心率驾驶舱',
      breadList: [{ name: '教学班心率驾驶舱', path: '/cockpit/clubcockpit/clubcockpit' }],
    },
    children: [],
  },
  {
    path: '/cockpit/venuesorder',
    name: 'venuesorder',
    component: require('@/view/cockpit/venuesorder/venuesordercockpit').default,
    meta: {
      title: '场馆预约驾驶舱',
      keepAlive: true,
      breadList: [{ name: '场馆预约驾驶舱', path: '/cockpit/venuesordercockpit' }],
    },
    children: [],
  },
  {
    path: '/cockpit/eachvenues',
    name: 'eachvenues',
    component: require('@/view/cockpit/venuesorder/eachvenues').default,
    meta: {
      title: '场馆预约驾驶舱',
      breadList: [{ name: '场馆预约驾驶舱', path: '/cockpit/eachvenues' }],
    },
    children: [],
  },
  {
    path: '/print/index',
    name: 'print',
    component: require('@/view/print/index').default,
    meta: {
      title: '大学生健康档案',
      breadList: [{ name: '健康档案打印', path: '/print/index' }],
    },
    children: [],
  },
  {
    path: '/appointment/inforegist',
    name: 'inforegist',
    component: require('@/view/appointment/inforegist').default,
    meta: {
      title: '校外人员预约',
      breadList: [{ name: '校外人员预约', path: '/appointment/inforegist' }],
    },
    children: [],
  },
  {
    path: '/appointment/index',
    name: 'inforegist-index',
    component: require('@/view/appointment/index').default,
    meta: {
      title: '校外人员首页',
      keepAlive: true,
      scrollToTop: false,
      breadList: [{ name: '校外人员首页', path: '/appointment/index' }],
    },
    children: [],
  },
  {
    path: '/appointment/takeface',
    name: 'inforegist-takeface',
    component: require('@/view/appointment/takeface').default,
    meta: {
      title: '人脸录入',
      breadList: [{ name: '人脸录入', path: '/appointment/takeface' }],
    },
    children: [],
  },
  {
    path: '/appointment/myinfo',
    name: 'inforegist-myinfo',
    component: require('@/view/appointment/myinfo').default,
    meta: {
      title: '我的信息',
      breadList: [{ name: '我的信息', path: '/appointment/myinfo' }],
    },
    children: [],
  },
  {
    path: '/appointment/venuesinfo',
    name: 'inforegist-venuesinfo',
    component: require('@/view/appointment/venuesinfo').default,
    meta: {
      title: '场馆介绍',
      breadList: [{ name: '场馆介绍', path: '/appointment/venuesinfo' }],
    },
    children: [],
  },
  {
    path: '/appointment/order',
    name: 'inforegist-order',
    component: require('@/view/appointment/order').default,
    meta: {
      title: '我的预约',
      breadList: [{ name: '我的预约', path: '/appointment/order' }],
    },
    children: [],
  },
  {
    path: '/appointment/actully',
    name: 'inforegist-actully',
    component: require('@/view/appointment/actully').default,
    meta: {
      title: '场地实况',
      breadList: [{ name: '场地实况', path: '/appointment/actully' }],
    },
    children: [],
  },
  {
    path: '/appointment/addorder',
    name: 'inforegist-addorder',
    component: require('@/view/appointment/addorder').default,
    meta: {
      title: '新增预约',
      //   keepAlive: true,
      breadList: [{ name: '新增预约', path: '/appointment/addorder' }],
    },
    children: [],
  },
  {
    path: '/appointment/ordersubmit',
    name: 'inforegist-ordersubmit',
    component: require('@/view/appointment/ordersubmit').default,
    meta: {
      title: '订单确认',
      breadList: [{ name: '订单确认', path: '/appointment/ordersubmit' }],
    },
    children: [],
  },
  {
    path: '/appointment/orderinfo',
    name: 'inforegist-orderinfo',
    component: require('@/view/appointment/orderinfo').default,
    meta: {
      title: '订单详情',
      breadList: [{ name: '订单详情', path: '/appointment/orderinfo' }],
    },
    children: [],
  },
  {
    path: '/appointment/invoice',
    name: 'inforegist-invoice',
    component: require('@/view/appointment/invoice').default,
    meta: {
      title: '发票抬头设置',
      breadList: [{ name: '发票抬头设置', path: '/appointment/invoice' }],
    },
    children: [],
  },
  {
    path: '/appointment/invoiceset',
    name: 'inforegist-invoiceset',
    component: require('@/view/appointment/invoiceset').default,
    meta: {
      title: '发票设置',
      breadList: [{ name: '发票设置', path: '/appointment/invoiceset' }],
    },
    children: [],
  },
  {
    path: '/appointment/paid',
    name: 'inforegist-paid',
    component: require('@/view/appointment/paid').default,
    meta: {
      title: '付款成功',
      breadList: [{ name: '付款成功', path: '/appointment/paid' }],
    },
    children: [],
  },
  {
    path: '/appointment/payfail',
    name: 'inforegist-payfail',
    component: require('@/view/appointment/payfail').default,
    meta: {
      title: '付款失败',
      breadList: [{ name: '付款失败', path: '/appointment/payfail' }],
    },
    children: [],
  },
  {
    path: '/appointment/refund',
    name: 'inforegist-refund',
    component: require('@/view/appointment/refund').default,
    meta: {
      title: '退款',
      breadList: [{ name: '退款', path: '/appointment/refund' }],
    },
    children: [],
  },
  {
    path: '/appointment/invite',
    name: 'inforegist-invite',
    component: require('@/view/appointment/invite').default,
    meta: {
      title: '邀请伙伴',
      breadList: [{ name: '邀请伙伴', path: '/appointment/invite' }],
    },
    children: [],
  },
  {
    path: '/appointment/friendmanage',
    name: 'inforegist-friendmanage',
    component: require('@/view/appointment/friendmanage').default,
    meta: {
      title: '伙伴管理',
      breadList: [{ name: '伙伴管理', path: '/appointment/friendmanage' }],
    },
    children: [],
  },
  {
    path: '/appointment/addfriend',
    name: 'inforegist-addfriend',
    component: require('@/view/appointment/addfriend').default,
    meta: {
      title: '添加新伙伴',
      breadList: [{ name: '添加新伙伴', path: '/appointment/addfriend' }],
    },
    children: [],
  },
  {
    path: '/appointment/cancelorder',
    name: 'inforegist-cancelorder',
    component: require('@/view/appointment/cancelorder').default,
    meta: {
      title: '取消预约申请',
      breadList: [{ name: '取消预约申请', path: '/appointment/cancelorder' }],
    },
    children: [],
  },
]
